import React from 'react';
import { BooleanInput, SearchInput } from 'react-admin';

import GetAppIcon from '@mui/icons-material/GetApp';

import AddressRow from './AddressRow';
import List, { ListActions } from '../common/views/List';
import IconButton from '../common/buttons/IconButton';

import { API_URL } from '../../services/settings';


const AddressListActions = (props) => (
    <ListActions {...props}>
        <IconButton icon={<GetAppIcon />} component="a" href={`${API_URL}/addresses/export.xls`}>Export</IconButton>
    </ListActions>
);

const addressFilters = [
    <SearchInput source="q" alwaysOn />,
    <BooleanInput label="Archived" source="archived" alwaysOn />
];

const filterDefaultValues = {
    archived: false
};

const AddressList = props => (
    <List {...props} filters={addressFilters} filterDefaultValues={filterDefaultValues} actions={<AddressListActions />} exporter={false} >
        <AddressRow />
    </List>
);

export default AddressList;